export default __webpack_public_path__ + "static/media/about-1.29970ca3.svg";